var React = require('react');

function AddInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M14,0.893398261 C15.3807119,0.893398285 16.5,2.0126864 16.5,3.39339826 L16.4993983,11.4993983 L24.6066017,11.5 C25.9873136,11.5 27.1066017,12.6192881 27.1066018,14 C27.1066017,15.3807119 25.9873136,16.5 24.6066018,16.5 L16.4993983,16.4993983 L16.5,24.6066018 C16.5,25.9873136 15.3807119,27.1066017 14,27.1066018 C12.6192881,27.1066017 11.5,25.9873136 11.5,24.6066017 L11.4993983,16.4993983 L3.39339826,16.5 C2.0126864,16.5 0.893398285,15.3807119 0.893398261,14 C0.893398311,12.6192881 2.0126864,11.5 3.39339833,11.5 L11.4993983,11.4993983 L11.5,3.39339833 C11.5,2.0126864 12.6192881,0.893398311 14,0.893398261 Z","transform":"translate(0 -.5)"}));
}

AddInline.defaultProps = {"width":"28","height":"27","viewBox":"0 0 28 27"};

module.exports = AddInline;

AddInline.default = AddInline;
